import React, { Suspense, lazy } from 'react';
import { Heading } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';

const LoadedTypeformEmbed = lazy(() => import(`../atoms/TypeformEmbedScript`));

const LoadingComponent = () => (
  <Heading
    as="h4"
    fontSize={{ base: `lg`, md: `3xl` }}
    color="white"
    pt={{ base: 8, md: 10 }}
    mb={{ base: 6, md: 8 }}
    textTransform="uppercase">
    Loading Form....
  </Heading>
);

const TypeformEmbed = ({ data: { formTitle, formCode } }) => {
  return (
    <Wrapper>
      {typeof formTitle !== `undefined` && formTitle !== null && (
        <Heading
          as="h2"
          fontSize={{ base: `lg`, md: `3xl` }}
          color="white"
          pt={{ base: 8, md: 10 }}
          mb={{ base: 6, md: 8 }}
          textTransform="uppercase">
          {formTitle}
        </Heading>
      )}

      <Suspense fallback={<LoadingComponent />}>
        <LoadedTypeformEmbed formCode={formCode} />
      </Suspense>
    </Wrapper>
  );
};

export default TypeformEmbed;
